var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-customer-group-form" }, [
    _c(
      "div",
      { staticClass: "form" },
      [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("wp.broadcast.groupName"))),
            ]),
            _vm._v(" "),
            _c(
              "a-input",
              {
                ref: "userNameInput",
                attrs: { placeholder: _vm.$t("wp.groupNameSearch") },
                model: {
                  value: _vm.groupName,
                  callback: function ($$v) {
                    _vm.groupName = $$v
                  },
                  expression: "groupName",
                },
              },
              [
                _c("a-icon", {
                  attrs: { slot: "prefix", type: "user" },
                  slot: "prefix",
                }),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      slot: "suffix",
                      title: _vm.$t("wp.groupNameDesc"),
                    },
                    slot: "suffix",
                  },
                  [
                    _c("a-icon", {
                      staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                      attrs: { type: "info-circle" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("a-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "a-button",
              { attrs: { disabled: _vm.loading }, on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                },
                on: { click: _vm.save },
              },
              [_vm._v(_vm._s(_vm.$t("wp.save")) + "\n            ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }